module.exports = __webpack_public_path__ + "static/media/veggie animal 3.5c38c33c.jpg";